import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Chave de API',
  state: {
    active: 'Ativa',
    revoked: 'Revogada',
  },
  createdBy: 'Gerada por',
  createdByValue: 'Equipe Bodyprint · {{date}}',
  lastUsed: 'Último uso',
  neverUsed: 'Ainda não usada',
  revokedAt: 'Revogada em',
  hint: 'A chave completa foi entregue uma única vez. Para trocar ou revogar,',
  support: 'fale com a equipe Bodyprint',
} satisfies TranslationTree;
